// @ts-nocheck
export const localeCodes =  [
  "cs",
  "sk",
  "de_DE",
  "hu_HU",
  "pl_PL",
  "en"
]
export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_46ts_028bfc6a",
      load: () => import("#nuxt-i18n/028bfc6a" /* webpackChunkName: "locale_cs_46ts_028bfc6a" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46ts_ef9e5f6b",
      load: () => import("#nuxt-i18n/ef9e5f6b" /* webpackChunkName: "locale_sk_46ts_ef9e5f6b" */),
      cache: true
    }
  ],
  de_DE: [
    {
      key: "locale_de_DE_46ts_e6659654",
      load: () => import("#nuxt-i18n/e6659654" /* webpackChunkName: "locale_de_DE_46ts_e6659654" */),
      cache: true
    }
  ],
  hu_HU: [
    {
      key: "locale_hu_HU_46ts_d7791579",
      load: () => import("#nuxt-i18n/d7791579" /* webpackChunkName: "locale_hu_HU_46ts_d7791579" */),
      cache: true
    }
  ],
  pl_PL: [
    {
      key: "locale_pl_PL_46ts_641e54bd",
      load: () => import("#nuxt-i18n/641e54bd" /* webpackChunkName: "locale_pl_PL_46ts_641e54bd" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46ts_59ee8f2c",
      load: () => import("#nuxt-i18n/59ee8f2c" /* webpackChunkName: "locale_en_46ts_59ee8f2c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "cs",
    language: "cs"
  },
  {
    code: "sk",
    language: "sk"
  },
  {
    code: "de_DE",
    language: "de"
  },
  {
    code: "hu_HU",
    language: "hu"
  },
  {
    code: "pl_PL",
    language: "pl"
  },
  {
    code: "en",
    language: "en"
  }
]
/** client **/

/** client-end **/